import { NavItemsSimple } from '@/components/custom/nav-Items-simple'
import { useProjectStore } from '@/core/project/store/project.store'
import { useSceneStore } from '@/features/shared/stores/scene.store'
import WorkspaceSidebarScaffold from '@/features/workspace/components/WorkspaceSidebarScaffold'
import { getShotListFromDB } from '@/service/shotlist-db'
import { Sidebar } from '@/shared/components/ui/sidebar'
import React from 'react'
import { downloadShotListPDF } from '../service/pdf-service'
import { Shot, useShotListStore } from '../store/useShotListStore'

export function SlSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
    const { scenes, editor } = useSceneStore()
    const { project } = useProjectStore()
    const { shotLists, selectedSceneNode } = useShotListStore()

    const handleDownload = async (type: 'whole' | 'single') => {
        console.log("handleDownload clicked", { type, project, scenesCount: scenes.length, shotListsKeys: Object.keys(shotLists) })
        if (!editor) {
            console.error("Editor instance missing for export")
            alert("Editor instance is missing. Please refresh the page.")
            return
        }
        if (!project) {
            console.error("Project ID missing for export")
            alert("Project ID is missing. Please refresh the page.")
            return
        }

        try {
            let shotListsToExport = shotLists

            // For whole movie export, load all shot lists from DB
            if (type === 'whole') {
                console.log("Loading all shot lists from DB for whole movie export...")
                const allShotLists: Record<string, Shot[]> = {}

                for (const scene of scenes) {
                    const sceneId = (scene as any).id
                    const shotsFromDB = await getShotListFromDB(project.id, sceneId)
                    if (shotsFromDB && shotsFromDB.length > 0) {
                        allShotLists[sceneId] = shotsFromDB
                    }
                }

                console.log("Loaded shot lists for scenes:", Object.keys(allShotLists))
                shotListsToExport = allShotLists
            }

            const projectTitle = project?.title || "Untitled Project"
            console.log("Calling downloadShotListPDF with title:", projectTitle)
            await downloadShotListPDF(
                projectTitle,
                scenes,
                shotListsToExport, editor,
                {
                    type,
                    sceneId: selectedSceneNode?.id || undefined
                }
            )
            console.log("Download complete.")
        } catch (error) {
            console.error("Error downloading PDF:", error)
            alert("Failed to download PDF. check console for details.")
        }
    }

    // REMOVED scene list as per user request

    const navItems = [
        {
            name: "Whole Movie Shot List",
            emoji: "📦",
            onClick: () => handleDownload('whole')
        },
        ...(selectedSceneNode ? [{
            name: "Current Scene Shot List",
            emoji: "📄",
            onClick: () => handleDownload('single')
        }] : [])
    ]

    return (
        <WorkspaceSidebarScaffold>
            <NavItemsSimple navItems={navItems} header={{ title: 'Shot List' }} />
        </WorkspaceSidebarScaffold>
    )
}

export default SlSidebar
